import React from 'react';
import { Link } from 'react-router-dom';
export type Crumb = {
  label: string;
  path: string;
};
type BreadcrumbsProps = {
  items: Crumb[];
};

/** Visible breadcrumb trail; the matching BreadcrumbList JSON-LD ships via Seo. */
export function Breadcrumbs({
  items
}: BreadcrumbsProps) {
  return <nav aria-label="Breadcrumb" className="mb-7 md:mb-8" data-id="element-15" data-mp="2m5jl17hqq4dx">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] text-mist" data-id="element-16" data-mp="2m84kjpukg88i">
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <li key={item.path} className="flex items-center gap-2" data-id="element-17" data-mp="1uh89mus2gdnv" data-mpi={index}>
              {isLast ? <span aria-current="page" className="text-graphite" data-id="element-18" data-mp="28cacta5j3owz">
                  {item.label}
                </span> : <Link to={item.path} className="transition-colors hover:text-ink" data-id="element-19" data-mp="3jt0mx4d2p0vv">
                  {item.label}
                </Link>}
              {!isLast && <span aria-hidden="true" className="text-line" data-id="element-20" data-mp="la30d618yqud">
                  /
                </span>}
            </li>;
      })}
      </ol>
    </nav>;
}